import { render, staticRenderFns } from "./ConfiguracoesGerais.vue?vue&type=template&id=2d6a885f&scoped=true&"
import script from "./ConfiguracoesGerais.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesGerais.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesGerais.vue?vue&type=style&index=0&id=2d6a885f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a885f",
  null
  
)

export default component.exports